import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * InwardPage - Redirects to main Hub Ops page
 * The inward wizard has been moved to the main Hub Ops page.
 */
const InwardPage = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to main Hub Ops page
    navigate("/pharmeasy/hub-ops", { replace: true });
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <p className="text-slate-500">Redirecting to Hub Operations...</p>
    </div>
  );
};

export default InwardPage;
